import React from "react";

interface FormFieldProps {
  label: string;
  value: string; // MUST be string
  onChange: (val: string) => void;
  placeholder?: string;
  type?: "text" | "textarea" | "number";
  status?: "success" | "warning" | "error";
  helperText?: string;
}

const statusStyles = {
  success: "border-green-400 bg-green-50",
  warning: "border-yellow-400 bg-yellow-50",
  error: "border-red-400 bg-red-50",
};

const FormField: React.FC<FormFieldProps> = ({
  label,
  value,
  onChange,
  placeholder,
  type = "text",
  status,
  helperText,
}) => {
  const handleChange = (val: string) => {
    if (type === "number") {
      // allow ONLY digits (paste-safe)
      if (!/^\d*$/.test(val)) return;
    }
    onChange(val);
  };

  return (
    <div className="space-y-1">
      {label && (
        <label className="text-xs font-bold uppercase text-gray-700">
          {label}
        </label>
      )}

      {type === "textarea" ? (
        <textarea
          value={value}
          rows={4}
          placeholder={placeholder}
          onChange={(e) => handleChange(e.target.value)}
          className={`w-full p-1 rounded-lg border focus:outline-none text-xs ${
            status ? statusStyles[status] : "border-gray-300"
          }`}
        />
      ) : (
        <input
          type={type === "number" ? "text" : type}
          inputMode={type === "number" ? "numeric" : undefined}
          value={value}
          placeholder={placeholder}
          onChange={(e) => handleChange(e.target.value)}
          onKeyDown={
            type === "number"
              ? (e) => {
                  if (["e", "E", "+", "-", "."].includes(e.key)) {
                    e.preventDefault();
                  }
                }
              : undefined
          }
          onWheel={type === "number" ? (e) => e.currentTarget.blur() : undefined}
          className={`w-full p-1 rounded-lg border focus:outline-none text-xs ${
            status ? statusStyles[status] : "border-gray-300"
          }`}
        />
      )}

      {helperText && (
        <p className="text-xs text-gray-500">{helperText}</p>
      )}
    </div>
  );
};

export default FormField;
